import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Dictionary } from '@ngrx/entity';
import { CustomQuestionType, customQuestionTypes, Ranking } from 'globals/store/events.data';
import { CoreEntityType } from 'globals/store/share.data';
import { defaultDialogData, DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { MatRadioModule } from '@angular/material/radio';   
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputEditorComponent } from '../joi-input/input-editor';
import { EntityTypeDropdownComponent } from './entity-type-dropdown.component';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { DialogPositionNumbers } from 'globals/store/dialog.selector.data';

@Component({
    selector: 'custom-question-dialog',
    template: `
<dialog-wrapper
  [backgroundColor]="data.backgroundColor || defaultColor"
  [dialogTitle]="data.dialogTitle"
  [tiny]="true"
  [disabled]="false"
  [giveMeTwenty]="true"
  [cancelLeft]="true"
  [data]="data.position ? { position: data.position, dialogRef: dialogRef } : defaultDialogData()"
  (cancel)="dialogRef.close()"
  (submit)="dialogRef.close(data)"
>
  <type-select-dropdown *ngIf="data.type"
    [types]="typesMap"
    [entityType]="data.type"
    [ids]="data.typeIds || []"
    (selectIds)="selectIds($event)"
  ></type-select-dropdown>
  <input-editor
    [object]="data" 
    [prop]="'text'" 
    [joiStyling]="true"
    [placeholder]="'Enter '+(mode === 'text' ? 'text' : 'question')+'...'"
  ></input-editor>
  <div *ngIf="mode !== 'text'" class="settings-holder">
    <div class="types-holder">
      <h3>Response type:</h3>
      <mat-radio-group name="detail" class="detail-select" [(ngModel)]="data.questionType" required>
        <ng-container *ngFor="let type of questionTypes">
          <mat-radio-button *ngIf="data.isNew || type.id === data.questionType" [value]="type.id">
            {{ type.label }}
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
      <div class="hint">Response type cannot be changed{{ data.isNew ? ' later' : '' }}</div>
    </div>
    <div class="types-holder" style="margin-top: 10px;">
      <h3>Mandatory:</h3>
      <mat-checkbox  [(ngModel)]="data.isMandatory">Field is mandatory</mat-checkbox>
    </div>
  </div>
  
</dialog-wrapper> 
`,
    styles: [`
    type-select-dropdown { float: right; margin: 0 5px 10px; }
    .settings-holder {display: flex; justify-content: space-between;  align-items: start; }
    .types-holder { display: flex; align-content: baseline; justify-content: space-between; margin: 0 0 10px 5px; flex-direction: column; }
    mat-radio-group { display: flex; flex-direction: column; margin: 5px 0; }
    .left { margin: 0 15px 0px 0px; }
  `],
    standalone: true,
    imports: [DialogWrapperComponent, EntityTypeDropdownComponent, MatCheckboxModule, CommonModule, MatRadioModule, FormsModule, InputEditorComponent,
    ]
})

export class CustomQuestionDialog {
  defaultColor: string = null
  questionTypes = customQuestionTypes.filter(qtype => qtype.id !== 'text');
  typesMap: Dictionary<Ranking> = {}
  mode: 'questions' | 'text' = 'questions';
  defaultDialogData = defaultDialogData

  constructor(
    public dialogRef: MatDialogRef<CustomQuestionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CustomQuestionDialogData,
  ) {
    if (this.data.types) this.typesMap = makeMapFromListOfObjectsAndKey(this.data.types, 'id')
    if (this.data.questionType === 'text'){
      this.mode = 'text';
    }
  }

  selectIds(ids: string[]) {
    this.data.typeIds = ids
    console.log("SELECT IDS", ids)
  }
}

export interface CustomQuestionDialogData {
  type?: CoreEntityType
  dialogTitle: string
  backgroundColor?: string
  text: string
  position: DialogPositionNumbers
  typeIds?: string[]
  types: Ranking[]
  questionType: CustomQuestionType
  isMandatory?: boolean
  isNew?: boolean
}